<template>
  <div style="height: 100%;">
    <Header />
    <div class="main-wrapper plolicy-top-box width9440">
      <div class="search-box">
        <div class="search-input-box">
          <input type="type" placeholder="请输入搜索内容" name="" v-model="searchkey"><span class="button" @click="cliSearch">搜索</span>
        </div>
      </div>
      <div class="tab-list">
        <p>
          <a :class="{active: nav === 'zhibo'}" @click.stop="changeType('zhibo')">
            直播互动
          </a>
        </p>
        <p>
          <a :class="{active: nav === 'scenc'}" @click.stop="changeType('scenc')">
            智慧场景
          </a>
        </p>
      </div>
      <ul class="c-profile-lsit c-my-video" v-for="(item,index) in resultlist" :key="index">
        <li class="c-profile-lsit-li" @click="gotoDetail('/detail/video?vid='+item.vid+'&plat='+nav)">
          <div class="c-video-box">
            <img :src="item.cover">
            <a href="javascript:;" class="c-video-btn">
              <img src="../assets/main/play-icon.png">
            </a>
          </div>
          <div class="c-profile-center-box">
            <h3>{{item.title}}</h3>
            <p>{{item.tags}}</p>
            <div class="c-btn-box">
              {{item.createTime}}
            </div>
          </div>
          <div class="c-my-video-box">
            <!-- 移动端时间 -->
            <div class="c-btn-box">
              {{item.createTime}}
            </div>
            <!-- 移动端时间 -->
            <!-- <a href="javascript:;"><img src="../assets/main/delect-icon.png">删除</a>
              <a href="javascript:;"><img src="../assets/main/edit-icon.png">编辑</a> -->
          </div>
        </li>
      </ul>
      <div class="paging-box">
        <el-pagination layout="prev, pager, next" :page-size="limit" :total="count" @current-change="pagechange"></el-pagination>
      </div>
    </div>
    <Footer :isLogin="true" />
  </div>

</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import config from '@/config/index';
  import {
    searchVideos,
    getVideoById,
    searchPlatFormVideos
  } from "@/api/video.js"
  import {
    Pagination
  } from 'element-ui';
  export default {
    name: 'SceneView',
    components: {
      Header,
      Footer,
      [Pagination.name]: Pagination,
    },
    watch: {
      $route(to, from) {}
    },
    data() {
      return {
        resultlist: [],
        page: 1,
        limit: 10,
        count: 0,
        searchkey: '',
        nav: 'zhibo'
      }
    },
    mounted() {
      this.nav = 'zhibo'
      this.queryPlantVideo()
    },
    methods: {
      cliSearch() {
        if (this.nav === "zhibo") {
          this.queryPlantVideo
        } else {
          this.queryVideo
        }
      },
      pagechange(page) {
        this.page = page
        if (this.nav === "zhibo") {
          this.queryPlantVideo()
        } else {
          this.queryVideo()
        }
      },
      changeType(typ) {
        this.nav = typ
        if (typ === "zhibo") {
          this.queryPlantVideo()
        } else {
          this.queryVideo()
        }
      },
      queryPlantVideo() {
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchPlatFormVideos(), {
          searchkey,
          page,
          limit
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            this.count = res.data.count
            this.resultlist.splice(0,this.resultlist.length)
            for(var i = 0; i < res.data.list.length; i++){
              this.resultlist.push(res.data.list[i])
            }
            this.count = res.data.count
            for (var i = 0; i < this.resultlist.length; i++) {
              var item = this.resultlist[i]
              item.cover = `${config.HOST_IMG}${item.cover}`
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      queryVideo() {
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchVideos(), {
          searchkey,
          page,
          limit
        }).then(res => {
          console.log(res);
          if (res.code === 1) {
            this.resultlist.splice(0,this.resultlist.length)
              for(var i = 0; i < res.data.list.length; i++){
                this.resultlist.push(res.data.list[i])
              }
              this.count = res.data.count
              for (var i = 0; i < this.resultlist.length; i++) {
                var item = this.resultlist[i]
                item.cover = `${config.HOST_IMG}${item.cover}`
              }
            } else {
              this.$message.error(res.msg);
            }
        });
      },
      gotoDetail(path) {
        this.$router.push(path);
      },
    }
  }
</script>

<style scoped>
  @import url(../components/personal-center/publishproject.css);
  @import url(./Policy.css);

  .tab-list {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px solid #0091FF;
  }

  .tab-list a {
    display: block;
    float: left;
    color: #424141;
    font-size: 16px;
    width: 96px;
    text-align: center;
  }

  .tab-list a.active,
  .tab-list a:hover {
    background: #267FF2;
    color: #fff;
  }

  .paging-box {
    text-align: center;
    /* margin: 30px 0 30px 140px; */
    overflow: hidden;
  }

  @media screen and (max-width: 850px) {
    .tab-list {
      line-height: .72rem;
      height: .72rem;
    }

    .tab-list a {
      font-size: .26rem;
      width: 1.4rem;
    }

    .tab-list {
      display: flex;
      -webkit-display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
    }

    .tab-list p {
      display: flex;
    }

  }
</style>
